import { Alert, Box as MuiBox, Grid, styled, Typography } from "@mui/material"
import { observer } from "mobx-react-lite"
import { useStore } from "../../../app/stores/store"
import HomeTrendType from "./HomeTrendType"
import HomeTrendStartDate from "./HomeTrendStartDate"
import HomeTrendEndDate from "./HomeTrendEndDate"
import HomeTrendDownload from "./HomeTrendDownload"
import HomeTrendChart from "./HomeTrendChart"
import { HomeCard } from "../common/HomeCard"
import { useEffect } from "react"

const Box = styled(MuiBox)(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(2)
}))

const HomeTrend = () => {
    const { errorMessage, generateChart } = useStore().homeTrendChartStore
    const { selectedStation } = useStore().commonStore
    
    useEffect(() => {
        if (selectedStation) {
            generateChart(selectedStation.id)
        }
    }, [generateChart, selectedStation])
    
    return (
        <HomeCard title="Trend Chart">
            <HomeTrendDownload />
            <Box sx={{my: 2}}>
                <Typography fontWeight={600} mb={2} variant="h6">Filter</Typography>
                <Grid container rowSpacing={1} columnSpacing={3}>
                    {/* baris pertama */}
                    <Grid item lg={1} xs={2} display="flex" alignItems="center">
                        <Typography component="label" htmlFor="type">Type</Typography>
                    </Grid>
                    <Grid item lg={5} xs={4}>
                        <HomeTrendType />
                    </Grid>
                    <Grid item lg={1} xs={2}></Grid>
                    <Grid item lg={5} xs={4}></Grid>
                    {/* baris kedua */}
                    <Grid item lg={1} xs={2} display="flex" alignItems="center">
                        <Typography component="label" htmlFor="startDate">Start&nbsp;Date</Typography>
                    </Grid>
                    <Grid item lg={5} xs={4}>
                        <HomeTrendStartDate />
                    </Grid>
                    <Grid item lg={1} xs={2} display="flex" alignItems="center">
                        <Typography component="label" htmlFor="endDate">End&nbsp;Date</Typography>
                    </Grid>
                    <Grid item lg={5} xs={4}>
                        <HomeTrendEndDate />
                    </Grid>
                    {/* baris error */}
                    {errorMessage && (
                        <>
                            <Grid item lg={1} xs={2}></Grid>
                            <Grid item lg={11} xs={10}>
                                <Alert severity="error">{errorMessage}</Alert>
                            </Grid>
                        </>
                    )}
                </Grid>
            </Box>
            <HomeTrendChart isStation />
            <HomeTrendChart />
        </HomeCard>
    )
}

export default observer(HomeTrend)